// Axios instance + auth helpers — all API access goes through here.
import axios from "axios";
import { STORAGE_KEYS } from "./constants";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // Clear stale token so the auth guard redirects
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
    }
    return Promise.reject(err);
  }
);

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Erro inesperado";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

// Station (per-device fixed desk)
export const getStationDesk = () => localStorage.getItem(STORAGE_KEYS.STATION) || null;
export const setStationDesk = (desk) => {
  if (desk) localStorage.setItem(STORAGE_KEYS.STATION, desk);
  else localStorage.removeItem(STORAGE_KEYS.STATION);
};

// BroadcastChannel singleton (same-browser instant sync)
import { BROADCAST_CHANNEL } from "./constants";
let channelInstance = null;
export const getChannel = () => {
  if (channelInstance) return channelInstance;
  if (typeof BroadcastChannel === "undefined") return null;
  channelInstance = new BroadcastChannel(BROADCAST_CHANNEL);
  return channelInstance;
};

export const broadcast = (type, payload = {}) => {
  const ch = getChannel();
  if (!ch) return;
  ch.postMessage({ type, payload, ts: Date.now() });
};
